<template>
  <div class="about">
    <div class="about-content">
      <p>{{ $t('about.description') }}</p>
    </div>
    <h2>{{ $t('about.location') }}</h2>
    <div class="about-content">
      <p>{{ $t('about.location-text') }}</p>
    </div>
    <h2>{{ $t('about.host') }}</h2>
    <div class="about-content-host">
      <p class="host-text" v-html="$t('about.host-text')"></p>
      <div style="display: flex; align-items: center;">
        <img src="@/assets/comp/host.jpg" alt="Danka" class="host-image">
      </div>
    </div>
    <!-- Reviews Section -->
    <div class="reviews-section">
      <div class="reviews-header">
        <h2>{{ $t('about.reviewsTitle') }} 
          <p style="font-weight: bold; padding: 0; margin: 0; font-size: 0.85rem; color: var(--secondary-color); display: inline;">(4,97★)</p>
        </h2>
      </div>
      <div class="reviews-row-wrapper">
        <img
          class="arrow arrow-left"
          src="@/assets/comp/arrow_left.png"
          alt="Left"
          @click="scrollLeft"
        />
        <div class="reviews-row">
          <div
            v-for="(review) in visibleReviews"
            :key="review.name"
            class="review"
          >
            <div class="review-name">
              {{ review.name }}
              <span class="review-stars">
                <span v-for="n in 5" :key="n" class="star">★</span>
              </span>
            </div>
            <div class="review-text">{{ review.text }}</div>
          </div>
        </div>
        <img
          class="arrow arrow-right"
          src="@/assets/comp/arrow_right.png"
          alt="Right"
          @click="scrollRight"
        />
      </div>
    </div>
  </div>
</template>

<script>
const reviewContext = require.context('@/assets/review', false, /\.(txt)$/);
export default {
  name: 'AboutView',
  data() {
    return {
      reviews: [],
      currentIndex: 0,
      visibleReviews: [],
      reviewsPerPage: 3,
    }
  },
  mounted() {
    this.fetchReviews();
    this.updateReviewsPerPage();
    window.addEventListener('resize', this.updateReviewsPerPage);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateReviewsPerPage);
  },
  methods: {
    scrollLeft() {
      if (this.currentIndex === 0) {
        this.currentIndex = Math.max(0, this.reviews.length - this.reviewsPerPage);
      } else {
        this.currentIndex = this.currentIndex - 1;
      }
      this.updateVisibleReviews();
    },
    scrollRight() {
      if (this.currentIndex >= this.reviews.length - this.reviewsPerPage) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = this.currentIndex + 1;
      }
      this.updateVisibleReviews();
    },
    updateVisibleReviews() {
      this.visibleReviews = this.reviews.slice(this.currentIndex, this.currentIndex + this.reviewsPerPage);
    },
    updateReviewsPerPage() {
      const width = window.innerWidth;
      if (width < 600) {
        this.reviewsPerPage = 1;
      } else if (width < 900) {
        this.reviewsPerPage = 2;
      } else {
        this.reviewsPerPage = 3;
      }
      // Adjust currentIndex if needed
      if (this.currentIndex > this.reviews.length - this.reviewsPerPage) {
        this.currentIndex = Math.max(0, this.reviews.length - this.reviewsPerPage);
      }
      this.updateVisibleReviews();
    },
    async fetchReviews() {
      const reviewFiles = reviewContext.keys();
      // Shuffle the review files array to randomize the order
      const shuffledFiles = reviewFiles
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);

      this.reviews = shuffledFiles.map(filepath => {
        const fileName = filepath.replace(/^\.\//, '').replace(/\.(txt)$/, '');
        return {
          name: fileName.charAt(0).toUpperCase() + fileName.slice(1),
          text: reviewContext(filepath).default
        }
      });
      this.updateVisibleReviews();
    },
  }
}
</script>

<style scoped>
.about {
  padding: 2rem;
  padding-top: var(--header-height, 10px);
  max-width: 800px;
  margin: 0 auto;
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
  /* padding-bottom: 150px; */
}
.about-content-host {
  display: flex;
  align-items: center;
}
.host-image {
  width: 10em; 
  height: 10em; 
  border-radius: 50%; 
  object-fit: cover; 
  margin-left: 2em; 
  display: flex;
  justify-content: flex-end;
}
.host-text {
  width: 75%; 
  min-width: 300px; 
  margin: 0;
}

.reviews-section {
  max-width: 800px;
  margin: 0 auto;
}
.review-stars{
  float: right;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.reviews-row{
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.reviews-row-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.review{
  width: 200px;
  height: 160px;
  text-overflow: ellipsis;
  border: 2px solid var(--primary-color);
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.review-name {
  font-size: 1.0rem;
  border-bottom: 1px solid var(--primary-color);
  font-weight: bold;
  margin-bottom: 0.5em;
}
.review-text {
  font-size: 0.85rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  line-clamp: 5;
  height: 100px;
  white-space: normal;
}
.arrow{
  width: 40px;
  height: 60px;
  cursor: pointer;
  justify-self: center;
  align-self: center;
  transition: transform 0.1s;
}
.arrow:active {
  transform: scale(0.95);
}
@media (max-width: 900px) {
  .review {
    width: 90vw;
    max-width: 350px;
    height: 160px;
    font-size: 0.9rem;
  }
  .arrow {
    width: 32px;
    height: 48px;
  }
}
@media (max-width: 600px) {
  .about-content-host {
    flex-direction: column;
  }
  .host-image {
    margin: 1rem;
  }
  .host-text {
    width: 100%;
    min-width: 0;
  }
  .about {
    padding: 1rem;
  }
  .about-content {
    padding-bottom: 80px;
  }
  .reviews-section {
    max-width: 98vw;
    margin: 0 1vw;
  }
  .reviews-row-wrapper {
    gap: 12px;
  }
  .reviews-row {
    flex-direction: column;
    align-items: stretch;
  }
  .review {
    width: 90vw;
    max-width: 280px;
    min-width: 0;
    margin: 0.5rem auto;
    height: auto;
    font-size: 1rem;
    box-sizing: border-box;
  }
  .arrow {
    width: 28px;
    height: 40px;
  }
}
@media (max-width: 350px) {
  .reviews-section {
    max-width: 98vw;
  }
  .review {
    max-width: 220px;
    width: 90vw;
  }
  .arrow {
    width: 20px;
    height: 32px;
  }
  .reviews-row-wrapper {
    gap: 6px;
  }
}
</style>
